import React, { useEffect, useRef, useState, useCallback } from "react";
import { DefaultButton } from "@fluentui/react";
import ReusableDialog from "../components/popupModals/ReusableDialog";
import { useTheme } from "../theme/OAS365Theme";
import { subscribeVersionMismatch } from "./appVersionEventBus";

export function AppVersionProvider({ children }) {
  const themeConfig = useTheme();
  const [open, setOpen] = useState(false);
  const [serverVersion, setServerVersion] = useState();
  const shownRef = useRef(false);

  const handleUpdate = useCallback(() => {
    setOpen(false);
    window.location.reload();
  }, []);

  useEffect(() => {
    return subscribeVersionMismatch((version) => {
      if (shownRef.current) {
        return;
      }
      shownRef.current = true;
      setServerVersion(version);
      setOpen(true);
    });
  }, []);

  return (
    <>
      {children}
      <ReusableDialog
        isOpen={open}
        onClose={handleUpdate}
        isBlocking={true}
        showHeader={true}
        title="A new version of this application is available."
        dialogMinHeight={160}
        bodyMinHeight={80}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            padding: "8px 0",
          }}
        >
          <p
            style={{
              margin: 0,
              fontWeight: 400,
              fontSize: "15px",
              textAlign: "center",
              lineHeight: 1.5,
            }}
          >
            {serverVersion && (
              <>New Version: {serverVersion}<br /></>
            )}
            <br />
            Please update to continue.
          </p>
          <DefaultButton
            style={{
              color: themeConfig.colors?.buttonTextColor || "#FFFFFF",
              backgroundColor: themeConfig.colors?.themeDarkColor || "#106ebe",
              borderRadius: 25,
              fontWeight: themeConfig.fontWeight?.menuWeight || 400,
              minWidth: 120,
            }}
            text="Update"
            onClick={handleUpdate}
          />
        </div>
      </ReusableDialog>
    </>
  );
}

export default AppVersionProvider;
